import styled from 'styled-components';

export const ProjectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .buttons {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      gap: 16px;
    }
  }

  .box {
    width: 100%;
    min-height: 83vh;
    background: #fff;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #f1f3f5;
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0 auto;

    .actions-bar {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      button {
        /* border-color: #228be6;
        color: #228be6; */

        /* svg {
          transform: scale(1.5);
          path {
            stroke: #228be6;
          }
        } */
      }

      .warning-report {
        border-radius: 4px;
        border: 1px solid #fa5252;
        background: #fff;
        color: #fa5252;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        padding: 12px;
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
      }
    }

    .table_actions {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }

    .empty {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      h2 {
        margin-top: 16px;
        font-size: 24px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #2b313d;
      }

      p {
        margin-top: 12px;
        font-size: 16px;
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0em;
        text-align: left;
        color: #9f9f9f;
      }

      button {
        margin-top: 32px;
      }
    }
  }
`;

export const CreateProjectModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 617px;
  height: 324px;
  padding: 56px;
  background: #edf0f5;
  border-radius: 12px;
  margin-top: 10px;
  flex-direction: column;

  .box {
    background-color: #fff;
  }

  .actions {
    width: 100%;
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
`;

export const PeriodSelect = styled.div`
  border-radius: 8px;
  gap: 6px;
  border: 1px solid #7888f5;
  background: #fff;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4;
  box-shadow:
    0px 171px 48px 0px rgba(0, 0, 0, 0),
    0px 110px 44px 0px rgba(0, 0, 0, 0.01),
    0px 62px 37px 0px rgba(0, 0, 0, 0.05),
    0px 27px 27px 0px rgba(0, 0, 0, 0.09),
    0px 7px 15px 0px rgba(0, 0, 0, 0.1);
`;

export const PeriodText = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #2b313d;
  font-size: 14px;
`;

export const PeriodOption = styled.button`
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background: #fff;
  display: flex;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  color: #5c5d61;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  width: 75px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    svg {
      transform: rotate(90deg);
    }
  }
  svg {
    transition: 0.3s all ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(90deg)' : 'rotate(0deg)')};
  }
`;

export const LabelContainer = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;

  .action-label-content {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;

    svg {
      path {
        fill: ${({ color, noFill }) => !noFill && (color || '#228BE6')};
      }
    }
  }
`;

export const Label = styled.span`
  color: ${({ color }) => color || '#228BE6'};
  text-decoration: ${({ textDecoration }) => textDecoration};
`;

export const Placeholder = styled.span`
  color: #868e96;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
`;

export const SelectBadge = styled.button.attrs(props => ({
  'data-active': props.active ? 'true' : 'false'
}))`
  display: flex;
  height: 28px;
  min-height: 28px;

  max-width: 58px;
  min-width: 58px;
  padding: 0px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 4px;
  background: ${({ active }) => (active ? '#228BE6' : '#f1f3f5')};
  color: ${({ active }) => (active ? '#fff' : '#000')};
`;

export const BadgeContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 32px;

  button {
    background-color: #228be6;

    svg {
      path {
        fill: #fff;
      }
    }
  }
`;
